"use strict";

exports.__esModule = true;
var _AppHomeScreen = require("./AppHomeScreen");
Object.keys(_AppHomeScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AppHomeScreen[key]) return;
  exports[key] = _AppHomeScreen[key];
});